/**
 * PolicySlice State Definition
 * 
 * Defines the state interface and initial state for the policy slice.
 */

import { PolicyView } from '../types/policyTypes';

/**
 * State interface for the policy slice.
 * Follows the standard BaseSliceState pattern with policy-specific naming.
 */
export interface PolicySliceState {
  /** The current policy being viewed/edited, or null if none selected */
  currentPolicy: PolicyView | null;
  /** List of policies for the selected company */
  policies: PolicyView[];
  /** Currently selected company for filtering policies */
  selectedCompany: string;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the policy slice.
 */
export const initialState: PolicySliceState = {
  currentPolicy: null,
  policies: [],
  selectedCompany: '',
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
